import * as React from 'react';

import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router';

import { getSeoText } from './utils';

interface ISeo {
  title: string;
  description?: string;
  image?: string;
  canonical?: string;
}

export const Seo: React.FC<ISeo> = ({
  title,
  description,
  image,
  canonical,
}) => {
  const location = useLocation();
  let URL: string = `https://privatmegleren.no/nybygg${location.pathname}`;

  let img = CreateImageLink(image);

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="twitter:site" content="@PRIVAT_megleren" />
      <meta name="twitter:creator" content="@PRIVAT_megleren" />
      <meta name="twitter:card" content="" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image:src" content={img} />
      <meta property="og:title" content={title} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={URL} />
      <meta property="og:image" content={img} />
      <meta property="og:description" content={description} />
      <meta property="og:site_name" content="PrivatMegleren" />
      <meta itemProp="name" content={title ? title : ''} />
      <meta itemProp="description" content={description} />
      <meta itemProp="image" content={img} />
      <meta name="p:domain_verify" content="f665a9d2e04bdc20ecfd4d18cdb87987" />
      <link rel="canonical" href={URL} />
    </Helmet>
  );
};

const CreateImageLink = (value?: string) => {
  if (value && value.trim()) {
    if (
      value.trim().toLowerCase().startsWith('http://') ||
      value.trim().toLowerCase().startsWith('https://')
    ) {
      return value;
    }

    if (value.trim().length > 0 && value.trim() != '/') {
      return (
        `https://privatmegleren.no/nybygg/` +
        (value.trim().startsWith('/') ? value.trim().substring(1) : value)
      );
    }
  }

  return 'https://cdn.reeltime.no/pm_assets/img/bakgrunner/pmfront.jpg';
};
